/**
 * Decorator for setting the logger scope of an ILogger instance
 * @param name
 */
export default function loggerScope(name) {
    return (target, key) => {
        const logger = target[key];
        if (!logger) {
            throw "logger is no set yet";
        }
        target[key] = logger.scope(name);
    };
}
